import { render, staticRenderFns } from "./CategoryDropdownFilters.vue?vue&type=template&id=03b9dbe4&scoped=true&"
import script from "./CategoryDropdownFilters.vue?vue&type=script&lang=ts&"
export * from "./CategoryDropdownFilters.vue?vue&type=script&lang=ts&"
import style0 from "./CategoryDropdownFilters.vue?vue&type=style&index=0&id=03b9dbe4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b9dbe4",
  null
  
)

export default component.exports